import React, { useState, useContext } from 'react';
import DynamicIcon from '../ui/dynamic-icon';

const NavSection = ({ children, section, additionalclasses }) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleDrawer = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={`grid gap-[4px] mt-[8px] relative ${additionalclasses}`}>
            {section &&
                <div className='flex justify-between items-center custom-text-grey-400'>
                    <span className="px-[27px] text-[12px] poppins-regular">{section}</span>
                    {section && <DynamicIcon onClick={toggleDrawer} name={isOpen ? 'chevron-up' : 'chevron-down'} size={16} color='cursor-pointer pr-[15px] lg:pr-[12px]' />}
                </div>}
            <div className={`grid gap-1 transition-all duration-300 ${isOpen ? 'max-h-screen' : 'max-h-0 overflow-hidden'}`}>
                {children}
            </div>
        </div>
    );
};

export default NavSection;